<div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center mb-8 overflow-hidden">
  <h1 class="font-bold mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-full">{{ { key: 'knowHowFile' } | i18n }}</h1>
</div>

<div class="flex flex-col text-md">
  <p>
    {{ { key: 'additionalKnowHowFileInfo' } | i18n }}
  </p>
  <app-know-how-upload [fileType]="BbitPlaceBookingFileUploadType.KNOW_HOW_DOCUMENT"></app-know-how-upload>
</div>
